$(document).ready(function ($) {
    function updateQueryStringParameter(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";

        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            return uri + separator + key + "=" + value;
        }
    }

    function show(data) {
        let items = $(data);

        let blogCategory = $('.blog-category');
        blogCategory.append(items);
    }

    $('.button__loadmore').on('click', function (e) {
        e.preventDefault();

        let lastChild = $('.loadmore_wrap .item:last-child');
        let currentUrl = window.location.href;
        let newUrl = '';

        const urlParams = new URLSearchParams(window.location.search);

        const getQueryParam = (paramName, defaultValue = []) => {
            const paramValue = urlParams.get(paramName);
            return paramValue ? paramValue.split(',') : defaultValue;
        };

        let serviceTypes = getQueryParam('service-types');
        let industries = getQueryParam('industries');
        let expertises = getQueryParam('expertises');

        const currentPage = parseInt(urlParams.get('current_page')) || 1;
        newUrl = updateQueryStringParameter(currentUrl, 'current_page', currentPage + 1);
        history.pushState({}, '', newUrl);

        let data = {
            'action': 'loadmore_insights',
            'query': true_posts,
            'page': currentPage,
            'service_types': serviceTypes,
            'industries': industries,
            'expertises': expertises,
            'page_type': page_type
        };

        $.ajax({
            url: ajaxurl,
            data: data,
            type: 'POST',
            beforeSend: function (xhr) {
                $(".lottie-animation").css('display', 'block')
                $("#true_loadmore_new a").css('display', 'none')
            },
            success: function (response) {
                if (response.success) {
                    let max_pages = response.data.max_pages;
                    let content = response.data.content;

                    show(content);

                    if ((currentPage + 1) === max_pages) {
                        $("#true_loadmore_new").css('display', 'none');
                    } else {
                        $("#true_loadmore_new").css('display', 'flex');
                        $("#true_loadmore_new a").css('display', 'block');

                        $(".lottie-animation").css('display', 'none')
                    }
                } else {
                    $("#true_loadmore_new").remove();
                }

                $("html, body").animate({
                    scrollTop: $(lastChild).offset().top + lastChild.innerHeight() - 90 + "px"
                }, {
                    duration: 0,
                });
            }
        });
    });
});
